export default "/_next/static/images/622f95605721e4ad89230bdf106f7c73.jpg";